<div class="card-list-wrap">
  @for (dataItem of dataList; track dataItem; let i = $index) {
    <div class="card-list-row">
      <div class="card-list-item" [attr.data-cy-index]="i">
        <div class="card-list-top">
          <div class="card-title">
            {{ dataItem.titleShort | translate }} {{ dataItem.titleShortAfter | translate }}
          </div>
          @if (dataItem.textOneShort) {
            <div
              class="card-text-one"
              >
              {{ dataItem.textOneShort }}
            </div>
          }
        </div>
        <div class="card-list-label" [class.error]="dataItem.error" [class.warning]="dataItem.warning">
          @if (dataItem.error) {
            <img
              src="../../../../assets/svg/employer_erorr.svg"
              class="alert_icon"
              alt="Alert"
              >
          }
          @if (dataItem.warning) {
            <img
              src="../../../../assets/svg/employer_warning.svg"
              class="alert_icon"
              alt="Alert"
              >
          }
          <div class="card-title">
            <span>{{ dataItem.title | translate }} {{ dataItem.titleAfter }}</span>
          </div>
          @if (dataItem.textOne) {
            <div
              class="card-text-one"
              >
              {{ dataItem.textOne }}
            </div>
          }
          <div
            class="card-text-two notFull"
            [class.m-0-mobile]="!dataItem.textOne"
            >
            {{ dataItem.textTwo }}
          </div>
        </div>
        <app-button-edit
          [withText]="false"
          (clickEmitter)="clickButtonEditEvent(dataItem.idForActionButtons)"
        ></app-button-edit>
        <app-button-delete
          [isLoading]="dataItem.buttonDeleteLoading"
          [withText]="false"
          (clickEmitter)="clickButtonDeleteEvent(dataItem.idForActionButtons)"
        ></app-button-delete>
      </div>
      <div class="alert-info-wrap">
        @if (dataItem.warning) {
          <div class="alert-info warning">
            {{ dataItem.warning | translate }}
          </div>
        }
        <div class="alert-info" [class.error]="dataItem.error">
          @if (!dataItem.error && dataItem.noError) {
            {{ dataItem.noError | translate }}
          }
          @if (dataItem.error) {
            {{ dataItem.error | translate }}
          }
        </div>
      </div>
    </div>
  }

  @if (isButtonAddShown) {
    <div class="button-add-wrap">
      <app-button-add
        (clickEmitter)="clickButtonAddEvent()"
        [title]="buttonAddTitle"
        >
      </app-button-add>
    </div>
  }
</div>

